export const locale = {
  lang: 'sv-SE',
  data: {},
};
